import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-forgot',
    templateUrl: './forgot.component.html',
    styleUrls: ['./forgot.component.css'],
    standalone: false
})
export class ForgotComponent implements OnInit {

  constructor() { }
  user = {email:'',password:''};
  onSubmit() {}
        
  ngOnInit() {
  }

}
